<template>
  <div class="home-footer">
    <div class="home-footer-link">
      <span>首页</span><span>学习</span><span>爱好</span><span>其他</span>
    </div>
    <div class="home-footer-beian" style="width:460px;margin:0 auto;">
      <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=46010502000538">
        <img src="http://blog-qn.xueyuhuihui.com/%E5%A4%87%E6%A1%88%E5%9B%BE%E6%A0%87.png" style="float:left;"/>琼公网安备 46010502000538号</a>
      <a href="https://beian.miit.gov.cn/">琼ICP备2022003607号-1</a>
    </div>
    <!--<div class="home-footer-beian"><a href="https://beian.miit.gov.cn/" target="_blank">琼ICP备2022003607号-1</a></div>-->
  </div>
</template>

<script>
    export default {
        name: "FooterCommon",
      data: function () {
        return {
          param: ""
        }
      }
    }
</script>

<style scoped>
  div, span, a {
    margin: 0;
    padding: 0;
  }
  .home-footer {
    display: inline-block;
    width: 100%;
    height: 100px;
    border-style: solid;
    border-color: #797979;
    border-width: 2px 0;
  }
  .home-footer .home-footer-link {
    display: inline-block;
    margin: 10px auto;
    height: 50px;
    font-size: 30px;
    size: 70px;
    text-align: center;
  }
  .home-footer .home-footer-link span{
    margin: 10px 0;
    padding: 0 10px;
    border-style: solid;
    border-color: #000;
    border-width: 0 1px;
  }
  #home-footer .home-footer-beian{
    display: flex;
    flex-direction: row;
    margin: 10px 0;
    padding: 0 10px;
  }
  #home-footer .home-footer-beian a{
    margin: 0 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/FooterCommon.vue